import { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import LoadEuropeConvergenceAds from "../../components/advertisement/load-europe-convergence-ads";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Europe2023Banner from "./components/europe-2023-banner";

const Europe2023HotelTravel = () => {
  const path = "europe-2023%2FHotel-Travel";
  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);

  const [pageRendered, setPageRendered] = useState(false);

  const cachedGoogleAdsLoader = useMemo(() => <LoadEuropeConvergenceAds />, []);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  useEffect(() => {
    if (pageMenuData[0]?.result !== undefined) {
      setPageRendered(true);
    }
  }, [pageMenuData]);

  // Dynamic Scripts
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (pageMenuData[0]?.result[0]) {
      if (pageMenuData[0]?.result[0].javaScriptField) {
        setScriptHtmlString(pageMenuData[0].result[0].javaScriptField);
      }

      if (window.runGlobalScripts) {
        window.runGlobalScripts();
      }
    }
  }, [pageMenuData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "europe-2023-hotel-travel-script" });
  // End Dynamic Scripts

  return (
    <>
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      {/*pageRendered && cachedGoogleAdsLoader*/}
      <Europe2023Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      &nbsp;
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description }}></div>
    </>
  );
};

export default Europe2023HotelTravel;
